import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export interface DropDownProps {
    isCustomizable: boolean;
}

export const lynxDropdownStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(2),
            marginLeft: theme.spacing(4),
            minWidth: 150,
            maxWidth: 300,
            maxHeight: 100,
            backgroundColor: `${theme.colors.neutrals.neutral100}`,

            "& .MuiSelect-select:focus": {
                backgroundColor: "inherit",
            },
            "& .MuiInputBase-root": {
                border: `1px solid ${theme.colors.neutrals.neutral200}`,
                padding: 0,
            },
            "& .MuiSelect-root": {
                padding: ({ isCustomizable }: DropDownProps) => (isCustomizable ? "0px" : "10px"),
            },
            "& .MuiSelect-icon": {
                width: "12px",
                height: "12px",
                marginTop: "6px",
                marginRight: "10px",
            },
            "& .MuiPopover-paper": {
                maxHeight: "100px",
            },
        },
        noLabel: {
            marginTop: theme.spacing(2.5),
        },
        menuItem: {
            "&:hover": {
                backgroundColor: `${theme.colors.primary.blue75}`,
            },
        },
        label: { backgroundColor: "white", color: "black" },
        selected: {
            "&.Mui-selected": {
                backgroundColor: `${theme.colors.primary.blue500}`,
                color: "white",
            },
            "&.Mui-selected:hover": {
                backgroundColor: `${theme.colors.primary.blue500}`,
            },
        },
        container: {
            textAlign: "center",
        },
    })
);
